var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_286)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0051 0C26.39 0 34.0102 7.60996 34.0102 17.0051C34.0102 26.39 26.4002 34.0102 17.0051 34.0102C7.62016 34.0102 0 26.4002 0 17.0051C0 7.62016 7.60996 0 17.0051 0ZM26.3186 13.2001C26.3186 13.2001 26.135 11.8842 25.5638 11.3129C24.8395 10.5581 24.0234 10.5479 23.6562 10.5071C20.9937 10.3132 17.0051 10.3132 17.0051 10.3132H16.9949C16.9949 10.3132 12.9961 10.3132 10.3438 10.5071C9.9766 10.5479 9.16052 10.5581 8.43624 11.3129C7.86499 11.8842 7.68137 13.2001 7.68137 13.2001C7.68137 13.2001 7.48755 14.7405 7.48755 16.2808V17.7192C7.48755 19.2595 7.68137 20.7999 7.68137 20.7999C7.68137 20.7999 7.86499 22.1158 8.43624 22.6871C9.16052 23.4419 10.1092 23.4215 10.5377 23.5032C12.0576 23.646 17.0051 23.697 17.0051 23.697C17.0051 23.697 21.0039 23.6868 23.6664 23.5032C24.0336 23.4623 24.8497 23.4521 25.574 22.6973C26.1452 22.126 26.3288 20.8101 26.3288 20.8101C26.3288 20.8101 26.5227 19.2697 26.5227 17.7294V16.291C26.5227 14.7507 26.3288 13.2103 26.3288 13.2103L26.3186 13.2001ZM15.0261 19.4737V14.1284L20.1674 16.8113L15.0261 19.4737Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.af7a0750ae00832974030a27b806fc8b.svg";
export { ForwardRef as ReactComponent };